import React, { useEffect, useState } from "react";
import "./homeContent.css";
import { motion } from "framer-motion";
import { FaPaperPlane, FaEarthAmericas, FaCar } from "react-icons/fa6";
import Aos from "aos";
import "aos/dist/aos.css";

const HomeContent = () => {
  const [activeTab, setActiveTab] = useState("trip");
  const [tripType, setTripType] = useState("oneway");
  const [travelTime, setTravelTime] = useState("exact");

  // ✅ States for inputs
  const [formData, setFormData] = useState({
    whatsapp: "",
    arrival: "",
    departure: "",
    month: "",
    textMonth: "",
    location: "",
    stayDays: "",
    pickupLocation: "",
    pickupTime: "",
  });

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  // ✅ Input handler
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // ✅ Unified Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
const clean = (val) => (val === "" ? null : val);

    let payload = { type: activeTab };
    let endpoint = "/";

    if (activeTab === "trip") {
      payload = {
        ...payload,
         travel_time: travelTime,
  arrival_date: clean(formData.arrival),
  departure_date: clean(formData.departure),
  month: clean(formData.month) || clean(formData.textMonth),
  whatsapp_number: formData.whatsapp,
  email: formData.email,
  name: formData.name,
};
      endpoint = "/trip-requests";
    }

    if (activeTab === "find") {
      payload = {
        ...payload,
        location: formData.location,
        stay_days: formData.stayDays, 
      };
      endpoint = "/trip-requests"; // نفس الكنترولر
    }

    if (activeTab === "rent") {
  payload = {
    pickup_location: formData.pickupLocation,
    pickup_date: formData.pickupTime, // اسم متطابق مع الـ DB
    whatsapp_number: formData.whatsapp,
     email: formData.email,
  name: formData.name,
  };
  endpoint = "/car-requests";
}


    console.log("📩 Sending Request:", payload);

    try {
      const res = await fetch(`https://admin.echoegypttours.com/api${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log("✅ Response:", data);
      alert("✅ Request sent successfully!");
    } catch (err) {
      console.error("❌ Error:", err);
      alert("❌ Something went wrong!");
    }
  };

  return (
    <section className="homeContentMain">
      <div className="contentBox">
        {/* Tabs */}
        <div className="tabs">
          <button
            className={`tab ${activeTab === "trip" ? "active" : ""}`}
            onClick={() => setActiveTab("trip")}
          >
            <h1>
              <FaPaperPlane /> Make Trip
            </h1>
          </button>
          {/* <button
            className={`tab ${activeTab === "find" ? "active" : ""}`}
            onClick={() => setActiveTab("find")}
          >
            <h1>
              <FaEarthAmericas /> Find Trip
            </h1>
          </button> */}
          <button
            className={`tab ${activeTab === "rent" ? "active" : ""}`}
            onClick={() => setActiveTab("rent")}
          >
            <h1>
              <FaCar /> Rent Car
            </h1>
          </button>
        </div>

        {/* Dynamic Form */}
        <motion.form
          className="formBox"
          animate={{ opacity: 1, y: 0 }}
          onSubmit={handleSubmit}
        >
          {activeTab === "trip" && (
            <>
              <div className="options">
                <h4>When will you be traveling?</h4>
                <label>
                  <input
                    type="radio"
                    name="time"
                    value="exact"
                    checked={travelTime === "exact"}
                    onChange={() => setTravelTime("exact")}
                  />{" "}
                  Have An Exact Time
                </label>
                {/* <label>
                  <input
                    type="radio"
                    name="time"
                    value="approx"
                    checked={travelTime === "approx"}
                    onChange={() => setTravelTime("approx")}
                  />{" "}
                  Have An Approximate Time
                </label> */}
                <label>
                  <input
                    type="radio"
                    name="time"
                    value="notSure"
                    checked={travelTime === "notSure"}
                    onChange={() => setTravelTime("notSure")}
                  />{" "}
                  Not Sure Yet
                </label>
              </div>

              <div className="dates">
                {travelTime === "exact" && (
                  <>
                    {/* <div className="inputGroup"> */}
                      {/* <label htmlFor="arrival">Arrival Date</label> */}
                      <input
                        id="arrival"
                        type="date"
                        value={formData.arrival}
                        onChange={handleChange}
                      />
                    {/* </div> */}
                    {/* <div className="inputGroup">
                      <label htmlFor="departure">Departure Date</label>
                      <input
                        id="departure"
                        type="date"
                        value={formData.departure}
                        onChange={handleChange}
                      />
                    </div> */}
                  </>
                )}

                {travelTime === "approx" && (
                  // <div className="inputGroup">
                  //   <label htmlFor="month">Select Month</label>
                    <input
                      id="month"
                      type="month"
                      value={formData.month}
                      onChange={handleChange}
                    />
                  // </div>
                )}

                {travelTime === "notSure" && (
                  // <div className="inputGroup">
                    // {/* <label htmlFor="textMonth">Write the month</label> */}
                    <input
                      id="textMonth"
                      type="text"
                      placeholder="Month: e.g. July"
                      value={formData.textMonth}
                      onChange={handleChange}
                    />
                  // </div>
                )}
                
                 {/* <div className="inputGroup"> */}
                  {/* <label htmlFor="email">Your Email</label> */}
                  <input
                    id="email"
                    type="email"
                    placeholder="Email: e.g. john@gmail.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                {/* </div> */}
                 {/* <div className="inputGroup"> */}
                  {/* <label htmlFor="name">Your Name</label> */}
                  <input
                    id="name"
                    type="name"
                    placeholder="Name: e.g. Amged"
                    value={formData.name}
                    onChange={handleChange}
                  />
                {/* </div> */}
                

                {/* <div className="inputGroup"> */}
                  {/* <label htmlFor="whatsapp">Your WhatsApp Number</label> */}
                  <input
                    id="whatsapp"
                    type="tel"
                    placeholder="Whatsapp: e.g. +20 10 1234 5678"
                    value={formData.whatsapp}
                    onChange={handleChange}
                  />
                </div>
              {/* </div> */}

              <button type="submit" className="submitBtn">
                Send a Request
              </button>
            </>
          )}

          {activeTab === "find" && (
            <>
              <h4>Find Your Perfect Trip</h4>
              <div className="options">
                <select
                  id="location"
                  value={formData.location}
                  onChange={handleChange}
                >
                  <option value="">Choose your favorite place in Egypt</option>
                  <option value="Cairo">Cairo</option>
                  <option value="Luxor">Luxor</option>
                  <option value="Aswan">Aswan</option>
                  <option value="Sharm El-Sheikh">Sharm El-Sheikh</option>
                </select>
                <select
                  id="stayDays"
                  value={formData.stayDays}
                  onChange={handleChange}
                >
                  <option value="">How many days to stay in Egypt</option>
                  <option value="3">3 Days</option>
                  <option value="5">5 Days</option>
                  <option value="7">7 Days</option>
                  <option value="10+">10+ Days</option>
                </select>
              </div>
              <button type="submit" className="submitBtn">
                Find Trip
              </button>
            </>
          )}

          {activeTab === "rent" && (
            <>
              <div className="options">
                <h4>Type of Trip?</h4>
                <label>
                  <input
                    type="radio"
                    name="tripType"
                    value="oneway"
                    checked={tripType === "oneway"}
                    onChange={() => setTripType("oneway")}
                  />{" "}
                  One Way
                </label>
                <label>
                  <input
                    type="radio"
                    name="tripType"
                    value="round"
                    checked={tripType === "round"}
                    onChange={() => setTripType("round")}
                  />{" "}
                  Round Trip
                </label>
              </div>

              <div className="dates rent-car-grid">
                <input
                  id="pickupLocation"
                  type="text"
                  placeholder="Choose Pick-Up Location"
                  value={formData.pickupLocation}
                  onChange={handleChange}
                />
                <input
                  id="pickupTime"
                  type="datetime-local"
                  value={formData.pickupTime}
                  onChange={handleChange}
                />
                <input
                  id="whatsapp"
                  type="tel"
                  placeholder="Whatsapp: e.g. +20 10 1234 5678"
                  value={formData.whatsapp}
                  onChange={handleChange}
                />
                
                  <input
                    id="email"
                    type="email"
                    placeholder="Email: e.g. john@gmail.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
               
                 
               
              </div>

              <button type="submit" className="submitBtn">
                Send Request
              </button>
            </>
          )}
        </motion.form>
      </div>
    </section>
  );
};

export default HomeContent;
